import classNames from "classnames";
import styles from "./style.module.scss";
import { Icons } from "assets";
import Separator from "shared/components/common/separater";

const NeedHelp = () => {
  return (
    <div
      className={classNames(
        "flex flex-col w-full md:w-1/2 gap-8",
        styles.mainContainer
      )}
    >
      <div
        className={classNames(
          "flex flex-col  gap-4 pe-0 pb-0 md:pb-0 md:pe-10",
          styles.needHelpContainer
        )}
      >
        <h3>
          Need Help? <span>Contact Us!</span>
        </h3>
        <p>
          If you are experiencing any technical issues or have a question about
          our platform, please reach out to us through the email below. We will
          get back to you as soon as possible.
        </p>
        <div className={classNames("flex items-center gap-3")}>
          <div className={classNames(styles.mailContainer)}>
            <Icons.Mail2 />
          </div>
          <span>RASsupport@compgovpartners.com</span>
        </div>
      </div>
      <Separator />
      <div
        className={classNames(
          "flex flex-col gap-4 pe-0 pb-8 md:pb-0 md:pe-10",
          styles.needHelpContainer
        )}
      >
        <h3>
          User Manual & <span>FAQ</span>
        </h3>
        <p>
          Access our User Guide and Frequently Asked Questions to learn more
          about RAStrack and its features.
        </p>
        <div className={classNames("flex items-center gap-3")}>
          <div className={classNames(styles.mailContainer)}>
            <Icons.Document />
          </div>
          <span
            onClick={() => {
              window.open(
                "https://rastrack-api.compgovpartners.com/usermanual/usermanual.pdf",
                "_blank"
              );
            }}
            role="button"
          >
            Click to Download
          </span>
        </div>
      </div>
    </div>
  );
};

export default NeedHelp;
